import { render, staticRenderFns } from "./ThreadPostActions.vue?vue&type=template&id=1493cb7e&scoped=true"
import script from "./ThreadPostActions.vue?vue&type=script&lang=js"
export * from "./ThreadPostActions.vue?vue&type=script&lang=js"
import style0 from "./ThreadPostActions.vue?vue&type=style&index=0&id=1493cb7e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../client/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1493cb7e",
  null
  
)

export default component.exports